<template>
    <!--
            {
                id: int,
                nroafi: int,
                calle: string,
                nro: string,
                piso: string,
                dep: string,
                locid: int,
                recibecorreo: int,
                tipcontacto: int,
                cp: int,
                localidad: "string,
                codprov: int,
                desprov: string,
                destipcontacto: string
            }
    -->
    <div>
        <ValidationObserver ref="obs" v-slot="{ invalid, dirty }">
            <v-form name="FormEditarDomicilio" @submit.prevent="submit">
                <v-row>
                    <v-col cols="12" md="12">
                        <ValidationProvider rules="required" v-slot="v">
                            <v-autocomplete dense :error-messages="v.errors[0]" v-model="itemDataSelected.codprov"
                                :items="provincias" @input="cargarLocalidades" label="Provincia" return-object
                                item-text="desprovincia" item-value="codigoProvincia"></v-autocomplete>
                        </ValidationProvider>
                    </v-col>
                    <v-col v-if="itemDataSelected.codprov !== 1" cols="12" md="12">
                        <ValidationProvider rules="required" v-slot="v">
                            <v-autocomplete dense :error-messages="v.errors[0]" v-model="itemDataSelected.localidad"
                                @input="cargarCodigoPostal" :items="localidades" item-text="nombre" item-value="nombre"
                                return-object label="Localidad"></v-autocomplete>
                        </ValidationProvider>
                    </v-col>
                    <v-col v-if="itemDataSelected.codprov == 1" cols="12" md="8">
                        <ValidationProvider rules="required" v-slot="v">
                            <v-autocomplete dense :error-messages="v.errors[0]" v-model="itemDataSelected.calle"
                                :items="localidades" item-value="calle" return-object
                                :item-text="item => `${item.calle} - (${item.alturamax} - ${item.alturamin}) - C.P:${item.cp}`"
                                label="Calle" @input="selectCalle"></v-autocomplete>
                        </ValidationProvider>
                    </v-col>
                    <v-col v-if="itemDataSelected.codprov == 1" cols="12" md="4">
                        <ValidationProvider rules="required" v-slot="v">
                            <v-text-field dense v-model="itemDataSelected.nro" type="text" label="Nro."
                                :error-messages="v.errors[0]" @keydown="preventArrowKeys"></v-text-field>
                        </ValidationProvider>
                    </v-col>
                </v-row>
                <v-row v-if="itemDataSelected.codprov !== 1">
                    <v-col cols="6" md="6">
                        <ValidationProvider rules="required" v-slot="v">
                            <v-text-field dense v-model="itemDataSelected.calle" @keydown="preventArrowKeys"
                                :error-messages="v.errors[0]"
                                @input="itemDataSelected.calle = itemDataSelected.calle.toUpperCase()" type="text"
                                label="Calle">
                            </v-text-field>
                        </ValidationProvider>
                    </v-col>
                    <v-col cols="6" md="6">
                        <ValidationProvider rules="required" v-slot="v">
                            <v-text-field dense v-model="itemDataSelected.nro" type="text" label="Nro."
                                :error-messages="v.errors[0]"></v-text-field>
                        </ValidationProvider>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6" md="6">
                        <ValidationProvider v-slot="v">
                            <v-text-field dense v-model="itemDataSelected.piso" nro type="Piso"
                                label="Piso."></v-text-field>
                        </ValidationProvider>
                    </v-col>
                    <v-col cols="6" md="6">
                        <ValidationProvider v-slot="v">
                            <v-text-field dense v-model="itemDataSelected.dep"
                                @input="itemDataSelected.dep = itemDataSelected.dep.toUpperCase()"
                                label="Dpto."></v-text-field>
                        </ValidationProvider>
                    </v-col>
                    <v-col cols="12" md="12">
                        <ValidationProvider rules="required" v-slot="v">
                            <v-text-field dense v-model="itemDataSelected.cp" type="number" label="Código postal"
                                :error-messages="v.errors[0]" item-value="tcnt_id" @keydown="preventArrowKeys"
                                hide-spin-buttons></v-text-field>
                        </ValidationProvider>
                    </v-col>
                    <v-col cols="12" md="12">
                        <ValidationProvider rules="required" v-slot="v">
                            <v-select dense v-model="itemDataSelected.tipcontacto" :items="tipoContacto" return-object
                                @input="selectTipoContDom" item-text="tcnt_des_tipcontacto"
                                :error-messages="v.errors[0]" item-value="tcnt_id" label="Tipo de contacto">
                            </v-select>
                        </ValidationProvider>
                    </v-col>
                </v-row>
                <ValidationProvider :rules="{}" v-slot="v">
                    <v-checkbox v-model="itemDataSelected.recibecorreo" dense :error-messages="v.errors[0]"
                        :true-value=1 :false-value=0 :readonly="(initialRecibeCorreo)">
                        <template v-slot:label>
                            <div
                                :class="(itemDataSelected.recibecorreo) ? `font-weight-medium primary--text` : `dark--text font-weight`">
                                Marcar como medio de contacto principal.
                            </div>
                        </template>
                    </v-checkbox>
                </ValidationProvider>
                <v-row>
                    <v-col class="text-end">
                        <v-btn elevation="0" type="submit" color="primary" class="pa-5" :disabled="invalid">
                            <v-icon class="mr-2">mdi-map-marker-outline</v-icon>
                            Guardar cambios
                        </v-btn>
                    </v-col>
                </v-row>
            </v-form>
        </ValidationObserver>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
    },
    data() {
        return {
            itemDataSelected: {
                id: '',
                nroafi: '',
                calle: '',
                nro: '',
                piso: '',
                dep: '',
                locid: Number,
                recibecorreo: 0,
                tipcontacto: '',
                cp: '',
                localidad: '',
                codprov: '',
                desprov: '',
                destipcontacto: '',
            },
            local: '',
            idProvincia: '',
            initialDesTipContacto: '',
            initialRecibeCorreo: ''
        }
    },
    mounted() {
        if (this.accion == 'modificar') {
            this.itemDataSelected = { ...this.itemSelected, accion: 'M' }
            this.initialRecibeCorreo = this.itemSelected.recibecorreo
            this.initialDesTipContacto = this.itemSelected.destipcontacto
            this.getLocalidades({ datoComun: 'obtenerLocalidades', codigoProvincia: this.itemSelected.codprov })
        } else {
            this.itemDataSelected = {
                id: '',
                nroafi: '',
                calle: '',
                nro: '',
                piso: '',
                dep: '',
                locid: '',
                recibecorreo: 0,
                tipcontacto: '',
                cp: '',
                localidad: '',
                codprov: '',
                desprov: '',
                destipcontacto: '',
                accion: 'A'
            }
        }
        /*  if (this.titulo.includes('Editar')) {
             this.itemDataSelected = Object.assign({}, this.itemSelected)
             this.initialRecibeCorreo = this.itemDataSelected.recibecorreo
             this.initialDesTipContacto = this.itemDataSelected.destipcontacto
             //boolean es true cuando es modificacion
             this.modificacion = true
             this.getLocalidades({ datoComun: 'obtenerLocalidades', codigoProvincia: this.itemSelected.codprov })
         } else {
             this.itemDataSelected = {
                 id: '',
                 nroafi: '',
                 calle: '',
                 nro: '',
                 piso: '',
                 dep: '',
                 locid: '',
                 recibecorreo: 0,
                 tipcontacto: '',
                 cp: '',
                 localidad: '',
                 codprov: '',
                 desprov: '',
                 destipcontacto: '',
             }
             this.modificacion = false
             this.initialDesTipContacto = ''
             this.initialRecibeCorreo = ''
         } */
    },
    computed: {
        ...mapGetters('itemEdit', ['itemSelected']),
        ...mapGetters('common', ['tipoContacto', 'provincias', 'localidades']),
        ...mapGetters('auth', ['nroafi', 'isAuthenticated']),
        ...mapGetters(['hayDomicilioPrinc', 'domicilio', 'domicilioPrinc']),

    },
    methods: {

        ...mapActions('common', ['getCodigoPais', 'getNacionalidades', 'getTipoNacionalidad', 'getLocalidades', 'getTipoContactoFiltro']),
        ...mapActions(['sendDomicilio', 'refreshData']),
        ...mapActions('notificaciones', ['showSnack']),

        preventArrowKeys(event) {
            if (event.keyCode === 38 || event.keyCode === 40) {
                event.preventDefault();
            }
        },

        buscarPorTipContacto(itemDataSelected) {
            itemDataSelected['recibecorreo'] = parseInt(itemDataSelected['recibecorreo'])
            for (let i = 0; i < this.tipoContacto.length; i++) {
                if (this.tipoContacto[i].tcnt_id === itemDataSelected.tipcontacto) {
                    itemDataSelected['destipcontacto'] = this.tipoContacto[i].tcnt_des_tipcontacto
                }
            }
            return itemDataSelected;
        },
        //** Metodos para domicilios */
        cargarLocalidades(value) {
            //nombre de la provincia en mayuscula
            this.itemDataSelected.desprov = value.desprovincia.toUpperCase()

            //codigo provincia
            this.itemDataSelected.codprov = value.codigoProvincia

            //cargo las localidades
            this.getLocalidades({ datoComun: 'obtenerLocalidades', codigoProvincia: value.codigoProvincia })

            //lo seteo como 
            //this.itemDataSelected.recibecorreo = 1
        },
        cargarCodigoPostal(value) {
            this.itemDataSelected.localidad = value.nombre
            this.itemDataSelected.locid = value.id
            this.itemDataSelected.cp = value.cp
        },
        selectCalle(value) {
            this.itemDataSelected.calle = value.calle
            this.itemDataSelected.cp = value.cp
            this.itemDataSelected.locid = value.id
            this.itemDataSelected.localidad = value.nombre
        },
        /**
         * Maneja la selección del tipo de contacto para el domicilio.
         * Evita duplicados y actualiza los valores correspondientes.
         * @param {Object} value - Objeto seleccionado del tipo de contacto.
         */
        selectTipoContDom(value) {
            // Obtiene la descripción del tipo de contacto seleccionado
            const tipoSeleccionado = value.tcnt_des_tipcontacto;

            // Verifica si ya existe ese tipo de contacto en otro domicilio (excluyendo el actual)
            const existe = this.domicilio.some(
                d => d.destipcontacto === tipoSeleccionado && d.id !== this.itemDataSelected.id
            );

            if (existe) {
                // Muestra mensaje de error si ya existe
                this.showSnack({
                    message: `Ya existe el tipo ${tipoSeleccionado} que quiere seleccionar.`,
                    type: "400",
                });
                // Restablece el valor anterior de manera reactiva
                this.$nextTick(() => {
                    this.itemDataSelected.tipcontacto = '';
                });
                return;
            }

            // Actualiza los valores si no hay duplicados
            this.itemDataSelected.destipcontacto = tipoSeleccionado;
            this.itemDataSelected.tipcontacto = value.tcnt_id;
        },
        /**
         * Valida y envía el formulario de domicilio.
         * Si es modificación, actualiza el domicilio principal según corresponda.
         * Si es alta, marca como principal si es el único o si se selecciona como tal.
         */
        async submit() {
            // Valida todos los campos del formulario usando vee-validate
            const isValid = await this.$refs.obs.validate();
            if (!isValid) {
                this.showSnack({
                    message: `Error al intentar guardar contacto.`,
                    type: "400",
                });
                return;
            }

            this.itemDataSelected.nroafi = this.nroafi;

            // Función auxiliar para desmarcar domicilios principales
            const desmarcarPrincipales = () => {
                const aux = this.domicilio
                    .filter(e => e.id !== this.itemDataSelected.id)
                    .map(e => ({ ...e, recibecorreo: 0, accion: "M" }));
                aux.forEach(domicilio => this.sendDomicilio(domicilio));
            };

            if (this.accion === 'modificar') {
                if (this.itemDataSelected.recibecorreo == 1) {
                    desmarcarPrincipales();
                } else if (this.domicilio.length === 0) {
                    this.itemDataSelected.recibecorreo = 1;
                } else {
                    this.itemDataSelected.recibecorreo = 1;
                }
                this.sendDomicilio(this.itemDataSelected);
            } else {
                // Alta de domicilio
                if (this.domicilio.length === 0) {
                    this.itemDataSelected.recibecorreo = 1;
                } else if (this.itemDataSelected.recibecorreo == 1) {
                    // Si se marca como principal, desmarcar los demás
                    const aux = this.domicilio.map(e => ({ ...e, recibecorreo: 0, accion: "M" }));
                    aux.forEach(domicilio => this.sendDomicilio(domicilio));
                } else {
                    this.itemDataSelected.recibecorreo = 0;
                }
                this.sendDomicilio(this.itemDataSelected);
            }
            // Cierra el formulario/modal
            this.$emit('close');
        }
    },
    props: {
        accion: {
            type: String,
            required: true,
        },
    }
}

</script>